export const FORM_RESULT = {
  PENDING: "검토 중",
  PASS: "합격",
  FAIL: "불합격",
};

export const MEETING_RESULT = {
  PENDING: "검토 중",
  PASS: "합격",
  FAIL: "불합격",
};

export const RECRUITMENT_TYPE = {
  FORM_ONLY: "서류평가만",
  FORM_AND_MEETING: "서류 및 면접",
  MEETING_ONLY: "면접만",
};

export const RECRUITMENT_STATUS = {
  OPEN: "모집 중",
  FORM_REVIEWED: "서류 검토 중",
  TIME_SET: "면접 시간 조정 중",
  INTERVIEWED: "면접 진행 중",
  CLOSED: "모집 마감",
};
